import {
  getDownloadURL,
  ref as storageRef,
  uploadBytes,
  deleteObject,
} from 'firebase/storage';
import {firebaseStorage} from '../firebase';
import {FirebaseStorageFolder} from 'hubbl-shared';

const getFirebaseStorageImageUrl = async (imageRefPath: string) => {
  const imageRef = storageRef(firebaseStorage, imageRefPath);

  return getDownloadURL(imageRef);
};

const uploadImage = async (
  imageFile: File | Blob,
  companyId: string,
  eventId: string,
) => {
  const refUri = `${FirebaseStorageFolder.Companies}${companyId}/${FirebaseStorageFolder.Events}${eventId}`;

  const ref = storageRef(firebaseStorage, refUri);

  const snapshot = await uploadBytes(ref, imageFile);

  return snapshot.ref.fullPath;
};

const uploadProfilePicture = async (
  imageFile: File | Blob,
  companyId: string,
  userUid: string,
) => {
  const refUri = `${FirebaseStorageFolder.Companies}${companyId}/${FirebaseStorageFolder.ProfilePictures}${userUid}`;
  const ref = storageRef(firebaseStorage, refUri);
  const snapshot = await uploadBytes(ref, imageFile);
  return snapshot.ref.fullPath;
};

const uploadDraftImage = async (
  imageFile: File | Blob,
  companyId: string,
  draftId: string,
) => {
  const refUri = `${FirebaseStorageFolder.Companies}${companyId}/drafts/${draftId}/cover-image`;
  const ref = storageRef(firebaseStorage, refUri);
  const snapshot = await uploadBytes(ref, imageFile);
  
  // Return the download URL directly
  return await getDownloadURL(snapshot.ref);
};

const deleteDraftImage = async (companyId: string, draftId: string) => {
  const refUri = `${FirebaseStorageFolder.Companies}${companyId}/drafts/${draftId}/cover-image`;
  const ref = storageRef(firebaseStorage, refUri);
  
  try {
    await deleteObject(ref);
  } catch (error) {
    // Image might not exist, which is okay
    console.warn('Failed to delete draft image:', error);
  }
};

export const storage = {
  uploadImage,
  getFirebaseStorageImageUrl,
  uploadProfilePicture,
  uploadDraftImage,
  deleteDraftImage,
};
